module.exports = __webpack_public_path__ + "static/media/1920-service-2-3-min.0e733c79.jpg";